import * as noUiSlider from 'nouislider';

class Range {
  constructor(el) {
    this.wrapper = el;
    this.minInput = el.querySelector('.js-range-min-input')
    this.maxInput = el.querySelector('.js-range-max-input')
    this.range = el.querySelector('.js-range-slider');

    const minVal = Number(el.querySelector('.js-range-min-value').textContent);
    this.min = Number.isNaN(minVal) ? 0 : minVal;
    const maxVal = Number(el.querySelector('.js-range-max-value').textContent);
    this.max = Number.isNaN(minVal) ? 0 : maxVal;

    this.init();
  }

  init() {
    this.rangeSlider = noUiSlider.create(this.range, {
      start: [this.min, this.max],
      connect: true,
      range: {
        'min': this.min,
        'max': this.max
      }
    });
    this.minInput.addEventListener('change', (e) => this.setSliderValue([e.target.value, null]));
    this.maxInput.addEventListener('change', (e) => this.setSliderValue([null, e.target.value]));

    this.rangeSlider.on('update', (values, handle) => this.setInputValues(values))
  }

  setSliderValue(values) {
    this.rangeSlider.set(values);
  }

  setInputValues(values) {
    this.minInput.value = Number(values[0]).toFixed();
    this.maxInput.value = Number(values[1]).toFixed();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.range').forEach((item) => {
    new Range(item);
  })
});

